var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"ifr-content",staticStyle:{"overflow-y":"hidden"},attrs:{"id":_vm.domId,"width":"100%","height":"0","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }